<p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event.index)">
  <p-accordionTab header="{{ titulo }}" [selected]="tabSeleccionado === 'PASO'">
    <app-flujo-venta-agregar-tabla [tabView]="tabView"
                                   [lisPasos]="lisPasos" [secFija]="secFija"
                                   [lisSecuencia]="lisSecuencia"
                                   [lisTipoPersonas]="listaTiposPersonas"
                                   [lisVinculacion]="lisVinculacion"
                                   [HabilitarindicadorVinculacionPorPerfil]=true></app-flujo-venta-agregar-tabla>
  </p-accordionTab>

  <!-- TAB Restricciones Perfil por Vinculación -->
  <p-accordionTab header="{{ 'FLUJOVENTARESTRICCIONESPERFILXVINCULACION.LBL_FLUJOVENTARESTRICCIONESPERFILXVINCULACION' | translate }}"
                  [selected]="tabSeleccionado === 'RESPERXVIN'"
                  [disabled]="!tabView.flujoVenta?.idFlujoVentaPaso"
                  *ngIf="tabView.flujoVenta?.indicadorVinculacionPerfil">
                  <app-fv-restricciones-perfil-x-vinculacion [tabView]="tabView"></app-fv-restricciones-perfil-x-vinculacion>
  </p-accordionTab>
</p-accordion>
